module.exports = __webpack_public_path__ + "img/r-cb-yr1.db967f2e.gif";